import { Grid, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSwipeable } from "react-swipeable";
import "../../../Styles/ImageSwitcher.css";
import ReactImageMagnify from "react-image-magnify";

// Mirrors the .main-image-product breakpoints in ImageSwitcher.css, which
// can't apply directly since react-image-magnify needs pixel width/height as props.
const getImageSize = (width: number) => {
  if (width <= 380) return { width: 300, height: 314 };
  if (width <= 650) return { width: 340, height: 354 };
  if (width <= 768) return { width: 260, height: 254 };
  if (width <= 1024) return { width: 265, height: 279 };
  if (width <= 1400) return { width: 330, height: 344 };
  return { width: 430, height: 444 };
};

const ImageSwitcher = ({
  images,
  handleDialogOpen,
}: {
  images: string[];
  handleDialogOpen: (newImage: string) => void;
}) => {
  const [currentImage, setCurrentImage] = useState(images[0]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageSize, setImageSize] = useState(() =>
    getImageSize(window.innerWidth),
  );

  useEffect(() => {
    setCurrentImage(images[currentImageIndex]);
  }, [images, currentImageIndex]);

  useEffect(() => {
    const handleResize = () => setImageSize(getImageSize(window.innerWidth));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlers = useSwipeable({
    onSwipedLeft: () => handleNextImage(),
    onSwipedRight: () => handlePreviousImage(),
    delta: 10,
    trackMouse: false,
  });

  const [_error, setError] = useState(false);

  const handlePreviousImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Grid container direction="column" alignItems="center" >
      <Grid item onClick={() => handleDialogOpen(currentImage)} {...handlers} sx={{ position: "relative" }}>
      <ReactImageMagnify
        {...{
          smallImage: {
            alt: "Product",
            isFluidWidth: false,
            width: imageSize.width,
            height: imageSize.height,
            src: _error
              ? "/no-image.jpg"
              : `https://jewelryshopdoro.com/uploads/${currentImage}`,
            onError: () => setError(true),
          },
          largeImage: {
            src: _error
              ? "/no-image.jpg"
              : `https://jewelryshopdoro.com/uploads/${currentImage}`,
            width: 1200,
            height: 1600,
            onError: () => setError(true),
          },
          enlargedImagePosition: "over",
        }}
        style={{
          width: imageSize.width,
          height: imageSize.height,
          overflow: "hidden",
          display: "block",
          position: "relative",
        }}
        imageStyle={{
          objectFit: "cover",
          width: "100%",
          height: "100%",
        }}
      />
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            handlePreviousImage();
          }}
          sx={{
            position: "absolute",
            top: "50%",
            left: "0px",
            transform: "translateY(-50%)",
            zIndex: 10,
            color: "#FAF8F4",
          }}
        >
          <ArrowBackIosIcon sx={{ fontSize: 48 }} />
        </IconButton>
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            handleNextImage();
          }}
          sx={{
            position: "absolute",
            top: "50%",
            right: "0px",
            transform: "translateY(-50%)",
            zIndex: 10,
            color: "#FAF8F4"
          }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: 48 }} />
        </IconButton>
      </Grid>
      <Grid item className="small-images-row" sx={{ marginTop: "10px" }}>
        <Grid container direction="row" spacing={1} justifyContent="center">
          {images.map((image, index) => (
            <Grid item key={index} onClick={() => setCurrentImage(image)}>
              <img
                className={
                  "small-image-product" +
                  (currentImage === image ? " sp-thumb--active" : "")
                }
                alt="small"
                src={`https://jewelryshopdoro.com/uploads/${image}`}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ImageSwitcher;